/**
 * Market banner
 *
 * Shows once (per session, or permanently until dismissed, depending on
 * the "show once per session" theme setting) prompting the visitor to
 * confirm or change their shopping region/currency and language.
 *
 * - "Yes, shop in [CURRENCY]" submits Shopify's native localization form
 *   with the detected country pre-filled, switching market/currency.
 * - "Choose a different region" / "Choose region" expands a picker built
 *   from Shopify's own {% form 'localization' %}, listing every country
 *   and language actually configured in Settings -> Markets.
 * - Closing (the × button) just hides the banner without changing anything.
 */
(function () {
  var STORAGE_KEY_DISMISSED = 'marketBannerDismissed';
  var SESSION_KEY_SHOWN = 'marketBannerShownThisSession';

  var configEl = document.getElementById('market-banner-config');
  var banner = document.getElementById('market-banner');
  if (!configEl || !banner) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (err) {
    console.error('Market banner: invalid config JSON', err);
    return;
  }

  function alreadyDismissedPermanently() {
    try {
      return localStorage.getItem(STORAGE_KEY_DISMISSED) === '1';
    } catch (err) {
      return false;
    }
  }

  function alreadyShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY_SHOWN) === '1';
    } catch (err) {
      return false;
    }
  }

  function markShown() {
    try {
      sessionStorage.setItem(SESSION_KEY_SHOWN, '1');
    } catch (err) {
      // ignore
    }
  }

  function markDismissedPermanently() {
    try {
      localStorage.setItem(STORAGE_KEY_DISMISSED, '1');
    } catch (err) {
      // ignore
    }
  }

  function shouldShow() {
    if (alreadyDismissedPermanently()) return false;
    if (config.showOncePerSession && alreadyShownThisSession()) return false;
    return true;
  }

  function showBanner() {
    banner.classList.add('is-visible');
    banner.setAttribute('aria-hidden', 'false');
    markShown();
  }

  function hideBanner() {
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
  }

  // ----- INIT -----
  if (shouldShow()) {
    // Small delay so it doesn't compete with the page's initial paint/animations.
    window.setTimeout(showBanner, 600);
  }

  // ----- CLOSE -----
  var closeBtn = banner.querySelector('[data-market-banner-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      hideBanner();
      markDismissedPermanently();
    });
  }

  // ----- CONFIRM DETECTED COUNTRY -----
  var confirmBtn = banner.querySelector('[data-market-banner-confirm]');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      var countryCode = confirmBtn.getAttribute('data-country');
      if (!countryCode) return;

      // Build and submit Shopify's localization form programmatically
      // with the detected country, so it behaves exactly like picking
      // it manually from the dropdown would.
      var form = document.createElement('form');
      form.method = 'post';
      form.action = window.location.pathname + window.location.search;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'country_code';
      input.value = countryCode;
      form.appendChild(input);

      document.body.appendChild(form);
      markDismissedPermanently();
      form.submit();
    });
  }

  // ----- OPEN PICKER -----
  var openPickerBtn = banner.querySelector('[data-market-banner-open-picker]');
  var prompt = banner.querySelector('[data-market-banner-prompt]');
  var picker = banner.querySelector('[data-market-banner-picker]');
  if (openPickerBtn && prompt && picker) {
    openPickerBtn.addEventListener('click', function () {
      prompt.hidden = true;
      picker.hidden = false;
    });
  }

  // The picker's own <form> is Shopify's native localization form --
  // submitting it (via the "Update" button) reloads the page in the
  // newly selected market/language, so no extra JS is needed there.
  // We do still want the permanent-dismiss flag set once they've acted.
  var pickerForm = banner.querySelector('[data-market-banner-picker] form');
  if (pickerForm) {
    pickerForm.addEventListener('submit', function () {
      markDismissedPermanently();
    });
  }
})();
